import { ItemButton } from "./ItemButton";

const ButtonComponent = (props: any) => {
  const {
    record,
    checklistItem,
    handler
  } = props?.others;

  return (
    <div className={`btn-${props.elementName.toLowerCase()}`} style={{ marginBottom: 10 }}>
      <ItemButton
        id={props?.id}
        onClick={ () =>
         handler({
          record,
          checklistItem,
        }) }
      >
        {props.elementName} {checklistItem?.isRequired && "*"}
        {(props?.others?.data && typeof props?.others?.data === 'string') && props?.others?.data}
      </ItemButton>
    </div>
  );
};

export default ButtonComponent;